import { isEmpty, trim } from 'lodash';

class PlainTemplateFilters {
  appendNewLine(input: string) {
    if (isEmpty(input)) {
      return input;
    }

    return `${input}\n\n`;
  }

  conditionalBlock(input: string) {
    if (isEmpty(trim(input))) {
      return '';
    }

    return `${input}\n`;
  }
}

/*
 * Method exposed as template filters in plain template engine.
 */
angular.module('v6CoreModule').factory('plainTemplateFilters', () => {
  return new PlainTemplateFilters();
});
